import { getToken, getUid } from "@/utils/auth";
import axios, { InternalAxiosRequestConfig } from "axios";

// 公共原子参数，可根据实际需求扩展
const COMMON_PARAMS = {
  appId: "123", // 示例参数
  // 其他公共参数
  muid: getUid(),
};

// 创建 axios 实例
const instance = axios.create({
  // baseURL: "/api", // 如有需要可开启
  // timeout: 10000,
});

// 请求拦截器：自动附加公共参数
instance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // 处理 POST/PUT/PATCH 请求体为对象的情况
    if (
      config.method &&
      ["post", "put", "patch"].includes(config.method) &&
      config.data && typeof config.data === "object"
    ) {
      config.data = { ...COMMON_PARAMS, ...config.data };
    }
    // 处理 GET/DELETE 请求参数
    if (
      config.method &&
      ["get", "delete"].includes(config.method) &&
      config.params && typeof config.params === "object"
    ) {
      config.params = { ...COMMON_PARAMS, ...config.params };
    }
    // 设置鉴权header
    const token = getToken();
    const uid = getUid();
    if (token) config.headers.token = token;
    if (uid) config.headers.uid = uid;
    return config;
  },
//   error => Promise.reject(error)
error => Promise.resolve({ success: false, code: -1, code_msg: "请求配置错误", data: null })
);

// 响应拦截器：无论 HTTP 状态码如何，都返回统一对象
instance.interceptors.response.use(
    (response) => {      
      // HTTP 2xx
      return {
        success: true,
        code: response.data?.code ?? 0,
        code_msg: response.data?.code_msg ?? "",
        data: response.data?.data ?? response.data,
      } as any;
    },
    (error) => {
      // HTTP 非 2xx
      const res = error.response;
      return {
        success: false,
        code: res?.data?.code ?? res?.status ?? -1,
        code_msg: res?.data?.code_msg ?? res?.statusText ?? "网络异常",
        data: res?.data?.data ?? null,
      } as any;
    }
  );
  

export default instance; 